<route>
{
  "name": "courses",
  "meta": {
    "order": 1, "isVisible": true,
    "iconName": "mdi-book"
  }
}
</route>

<template>
  <div>
    <page-title
      :title="$t('pages.courses.title')">
      <v-btn
        outlined
        :to="{name: 'courseAdd'}"
        color="success">
        <v-icon
          class="ml-3">
          mdi-plus-thick
        </v-icon>
        {{$t('general.add')}}
      </v-btn>
    </page-title>
    <v-row
      v-if="!pageDataIsReady"
      >
      <v-col
        cols="12">
        <v-skeleton-loader
          type="table"
          ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-data-table
      v-if="pageDataIsReady"
      class="report-table"
      :headers="headers"
      :items="courseList"
      disable-sort
    >
      <template v-slot:item.actions="{ item }">
        <v-row class="flex-nowrap">
          <v-col cols="6" class="px-0">
            <v-btn
              icon
              color="primary"
              :to="{ name: 'courseEdit', params: { id: item._id.$oid } }">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="6" class="pr-0">
            <v-btn
              icon
              color="primary"
              :to="{ name: 'course', params: { id: item._id.$oid } }"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>
      <template slot="item.image" slot-scope="props">
          <router-link 
            :to="{ name: 'course', params: { id: props.item._id.$oid } }">
            <v-avatar
              tile
              class="btn pointer my-2 ml-2 rounded-lg"
              size="48">
              <v-img 
                :src="props.item.image">
              </v-img>
            </v-avatar>
          </router-link>
      </template>
      <template v-slot:item._id="{ item }">
        <div class="english-number">
          <pre> {{ item._id.$oid }} </pre>
        </div>
      </template>
      <template v-slot:item.draft="{ item }">
        <v-icon 
          color="green"
          v-if="item.draft">
           mdi-check-circle-outline
        </v-icon>
      </template>
      <template v-slot:item.enable="{ item }">
        <v-icon 
          color="green"
          v-if="item.enable">
          mdi-check-circle-outline
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'pageCourseList',
  layout: APP_CONFIG.layout.mainPanelLayout,
  data () {
    return {
      pageDataIsReady:  false,
      imageHeight: '150',
      col: '6',
      courseList: [],
      cardAnswerCount: null,
      badge: {
        medal: '/img/certificate.png'
      }
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('models.order'),
          width: 32,
          value: 'order'
        },
        {
          text: '', 
          width: 64,
          value: 'image'
        },
        {
          text: this.$t('models.name'),
          value: 'name'
        },
        {
          text: this.$t('models.description'),
          value: 'description'
        },
        {
          text: this.$t('models.draft'),
          width: 100,
          value: 'draft'
        },
        {
          text: this.$t('models.enable'),
          width: 100,
          value: 'enable'
        },
        {
          text: '', 
          value: 'actions'
        },
      ]
    },
  },
  methods: {
    onClick (item) {
      this.$router.push(`/course/${item._id.$oid}`)
    }
  },
  mounted () {
    this.$store.dispatch('course/getCourses').then((response) => {
      this.courseList = response.data
      this.pageDataIsReady = true
    })
  }
}
</script>
